<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" class="ml-3">
        NOVO EVENTO
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Cadastro de Evento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="showDialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              :label="`Nome ${isAT ? 'da agenda' : 'do encontro'}`"
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00:00"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00:00"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="9" sm="9" lg="9">
            <v-combobox
              v-model="payload.municipios"
              :items="municipios"
              chips
              clearable
              :label="isGov ? 'Projetos' : 'Municípios'"
              item-text="nome"
              item-value="municipioId"
              multiple
            >
            </v-combobox>
          </v-col>
          <v-col>
            <v-btn color="info" outlined text @click="selecionarTodos()"
              >Selecionar Todos</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="showDialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { eventAPI } from "@/modules/event";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertEvent",
  props: {
    dialog: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  data() {
    return {
      payload: {
        nome: null,
        municipios: [],
        observacoes: null,
      },
      menu: "",
      menu2: "",
      date: null,
      time: null,
      municipios: [],
      showDialog: this.dialog,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    save() {
      if (!this.payload.inicioString || this.payload.inicioString.length < 16) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de início do evento"
        );
      } else if (
        !this.payload.fimString ||
        this.payload.fimString.length < 16
      ) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de término do evento"
        );
      } else if (this.payload.municipios.length < 1) {
        this.$notification.error("É obrigatório selecionar os municípios");
      } else if (!this.payload.observacoes) {
        this.$notification.error(
          "É obrigatório o preenchimento das observações"
        );
      } else {
        this.setLoading(true);
        eventAPI
          .create(this.payload)
          .then((resp) => {
            this.$emit("onSave");
            this.showDialog = false;
            this.payload.nome = null;
            this.payload.municipios = [];
            this.payload.observacoes = null;
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao cadastrar evento");
          });
      }
    },
    loadCities() {
      this.setLoading(true);
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    selecionarTodos() {
      this.payload.municipios = this.municipios;
    },
  },
  created() {
    this.loadCities();
  },
};
</script>
